import { TipoDespesa } from './../tipo-despesa/tipo-despesa';
import { Fornecedor } from './../fornecedor/fornecedor.model';
import { BaseEntity } from 'src/app/core/domain/base.entity';
import { Suprimento } from '../suprimento/suprimento.model';
import { ItemDespesa } from '../item-despesa/item-despesa';
import { DocumentoComplementacao } from './documento-complementacao.model';

export class Despesa extends BaseEntity {
  fornecedor: Fornecedor;
  finalidade: string;
  dataNf: Date;
  numeroNf: string;
  tipoDespesa: TipoDespesa;
  suprimento: Suprimento;
  ativo: boolean;
  dataCadastro: Date;
  dataAtualizacao: Date;
  listaItemDespesa: ItemDespesa[];
  notaFiscal: DocumentoComplementacao;
}
